module.exports = __webpack_public_path__ + "img/home_business_3.cd86dc95.png";